import React, { useContext } from 'react'

import FeatureFlagContext from './FeatureFlagContext'
import FeatureFlagStatusContext from './FeatureFlagStatusContext'

// React hook for pulling feature flags into a function component
const useFeatureFlags = (flagKeys = []) => {
  const featureFlags = useContext(FeatureFlagContext)

  return flagKeys.reduce((agg, key) => {
    if (featureFlags[key] === undefined) {
      logError(key)
    }
    return [...agg, featureFlags[key]]
  }, [])
}

// True while the flags still reflect a different (e.g. not yet signed-in) user.
// Check it before redirecting away from a flag-gated page.
const useFeatureFlagsLoading = () =>
  useContext(FeatureFlagStatusContext).isLoading

const ShowFeatureWithFlags = props => {
  const [canUse] = useFeatureFlags([props.flag])
  const children = canUse ? props.children : null

  return <>{children}</>
}

const logError = key => {
  // Send Error to Raygun
  window.rg4js &&
    window.rg4js('send', {
      error: `No such flag exists for key: ${key}`,
      tags: ['useFeatureFlags'],
    })
}

export { useFeatureFlags, useFeatureFlagsLoading, ShowFeatureWithFlags }
